import React from "react";
import styled from "styled-components";
import ForwarderPageNavigation from "forwarder/ForwarderPageNavigation";
import { DocumentTitle, PageHeader } from "components/common";
import { Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import { InputProfilesActions } from "./stores/InputProfilesStore";
import withIsPermitted from "./util/withIsPermitted";
import InputProfileForm from "./input-profiles/InputProfileForm";
const REQUIRED_PERMISSIONS = ["inputprofiles:create"];
const StyledH2 = styled.h2`
  margin-bottom: 20px;
`;
const NewInputProfilePage = () => {
  const history = useHistory();
  const sendTelemetry = useSendTelemetry();
  const _handleInputProfileCreation = (inputProfile) => {
    history.push(ForwarderRoutes.PROFILE.details(inputProfile.id));
  };
  const _handleSubmit = (nextInputProfile) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_CREATED, {
      app_pathname: "forwarder",
      app_section: "input-profile"
    });
    InputProfilesActions.create(nextInputProfile).then((result) => {
      _handleInputProfileCreation(result);
      return result;
    });
  };
  const _handleCancel = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_CREATE_CANCELED, {
      app_pathname: "forwarder",
      app_section: "input-profile"
    });
    history.push(ForwarderRoutes.PROFILE.LIST);
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "New Input Profile" }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "New Input Profile",
      documentationLink: {
        title: "Input profile documentation",
        path: ForwarderDocs.INPUT_PROFILE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Use Input Profiles to create a set of Inputs that can be shared across many Forwarders.")
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(StyledH2, null, "Input Profile Details"), /* @__PURE__ */ React.createElement(InputProfileForm, { onCancel: _handleCancel, onSubmit: _handleSubmit, buttonText: "Create" }))));
};
export default withIsPermitted(NewInputProfilePage, REQUIRED_PERMISSIONS);
